import Model, { attr, belongsTo } from '@ember-data/model';

export default class ScheduleHistory extends Model {
  @attr('string') text;
  @attr('date') startDate;
  @attr('date') endDate;
  @attr('number', { defaultValue: 0 }) goodCount;
  @attr('number', { defaultValue: 0 }) rejectCount;
  @attr('number', { defaultValue: 0 }) targetCount;

  @belongsTo('schedule', { async: false, inverse: null }) schedule;
  @belongsTo('station', { async: false, inverse: null }) station;
}
